import { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../../../shared/API/apiClient";
import { useReportingYear } from "../../../context/ReportingYearContext";
import "../../../styles/pages/submissionTracker.css";

const FA_ICON_MAP={
  total:"fa-solid fa-list",
  approved:"fa-solid fa-check-double",
  locked:"fa-solid fa-lock",
  pending:"fa-solid fa-clock",
  evidence:"fa-solid fa-paperclip",
};

const BRSRWorkspace=()=>{

  const navigate=useNavigate();

  const {
    reportingYear,
    reportingYearId
  }=useReportingYear();

  const [isYearLocked,setIsYearLocked]=useState(false);

  const [legalEntities,setLegalEntities]=useState([]);

  const [selectedEntity,setSelectedEntity]=useState("");
  const [hasSelectedEntity,setHasSelectedEntity]=useState(false);

  const [workspace,setWorkspace]=useState(null);

  const [loading,setLoading]=useState(false);


  // =====================================
  // REPORTING YEAR LOCK STATUS
  // =====================================

useEffect(()=>{

  if(
    !reportingYearId ||
    !selectedEntity ||
    !hasSelectedEntity
  ){

    return;
  }

  let apiUrl=`/api/brsr/dashboard/${reportingYearId}`;

  if(selectedEntity!=="all"){

    apiUrl=`/api/brsr/dashboard/${reportingYearId}/${selectedEntity}`;
  }

  setLoading(true);

  apiClient
    .get(apiUrl)

    .then((res)=>{

      if(res.data?.success){

        setWorkspace(res.data);

      }else{

        setWorkspace(null);
      }

    })

    .catch(()=>{

      setWorkspace(null);

    })

    .finally(()=>{

      setLoading(false);

    });

},[
  reportingYearId,
  selectedEntity,
  hasSelectedEntity
]);

  // =====================================
  // LEGAL ENTITIES
  // =====================================

  useEffect(()=>{

    if(!reportingYearId){

      setLegalEntities([]);

      setSelectedEntity("all");

      return;
    }

    setLegalEntities([]);

    setSelectedEntity("all");

    apiClient

      .get(
        "/api/legal-entities-by-year",
        {
          params:{
            reporting_year_id:
              reportingYearId
          }
        }
      )

      .then((res)=>{

        if(res.data?.code===200){

          setLegalEntities(
            res.data?.data || []
          );

        }else{

          setLegalEntities([]);
        }

      })

      .catch(()=>{

        setLegalEntities([]);

      });

  },[reportingYearId]);

  // =====================================
  // REPORT READINESS
  // =====================================

  const readiness=
  workspace?.report_readiness || {};

const isReady=
  readiness?.is_ready ?? false;


  // =====================================
  // SUMMARY CARDS
  // =====================================

const statCards=[

  {
    key:"total",
    icon:FA_ICON_MAP.total,
    label:"Total Principles",
    value:loading
      ? "..."
      : (
          workspace?.summary
            ?.total_principles ?? 0
        ),
    color:"#F1F5F9",
    fg:"#334155"
  },

  {
    key:"approved",
    icon:FA_ICON_MAP.approved,
    label:"Approved",
    value:loading
      ? "..."
      : (
          workspace?.summary
            ?.approved ?? 0
        ),
    color:"#ECFDF5",
    fg:"#047857"
  },

  {
    key:"locked",
    icon:FA_ICON_MAP.locked,
    label:"Locked",
    value:loading
      ? "..."
      : (
          workspace?.summary
            ?.locked ?? 0
        ),
    color:"#F0F9FF",
    fg:"#0369A1"
  },

  {
    key:"pending",
    icon:FA_ICON_MAP.pending,
    label:"Pending Review",
    value:loading
      ? "..."
      : (
          workspace?.summary
            ?.pending_review ?? 0
        ),
    color:"#FFFBEB",
    fg:"#B45309"
  },

  {
    key:"evidence",
    icon:FA_ICON_MAP.evidence,
    label:"Evidence Files",
    value:loading
      ? "..."
      : (
          workspace?.summary
            ?.evidence_files ?? 0
        ),
    sub:"attached",
    color:"#F5F3FF",
    fg:"#6D28D9"
  }
];

  // =====================================
  // WORKSPACE SECTIONS
  // =====================================

  const sections=
    workspace?.sections || [];

  return(

    <div className="dash-page">

      {/* =====================================
          PAGE HEADER
      ===================================== */}

      <div className="dash-page-title workspace-main-title">

        BRSR Workspace

      </div>

      <div className="dash-page-subtitle">

        Manage, review and finalize SEBI BRSR disclosures across Sections A, B and C before report export.

      </div>

      {/* =====================================
          FILTERS
      ===================================== */}

      <div className="filter-card">

        {/* REPORTING YEAR */}

        <div className="filter-group workspace-filter-stretch">

          <label>

            Reporting Year *

          </label>

          <input
            className="filter-input"
            value={reportingYear || ""}
            readOnly
            placeholder="Select a year from navbar"
          />

        </div>

        {/* LEGAL ENTITY */}

        <div className="filter-group workspace-filter-stretch">

          <label>

            Legal Entity *

          </label>

         <select
  className="filter-input"
  value={selectedEntity}
  onChange={(e)=>{

    setSelectedEntity(
      e.target.value
    );

    setHasSelectedEntity(true);

  }}
  disabled={!reportingYearId}
>

            <option value="all">

              All Legal Entities

            </option>

            {legalEntities.map((e)=>(

              <option
                key={e.entity_id}
                value={e.entity_id}
              >

                {e.entity_name}

              </option>

            ))}

          </select>

        </div>

      </div>

{!!workspace && (

  <>
      {/* =====================================
          READINESS BLOCK
      ===================================== */}

      <div className="workspace-upper-wrapper">

        <div className="workspace-top-bar">

          <div className="workspace-status-block">

            <i className="fa-solid fa-shield-halved" />

            <span className="workspace-bar-text">

              BRSR Report Readiness

            </span>

            <span
              className={`workspace-ready-badge ${
                isReady
                  ? "ready-on"
                  : "ready-off"
              }`}
              
            >

              {loading
                ? "..."
                : (
                    workspace?.report_readiness
                      ?.status_label || "Not Ready"
                  )
              }

            </span>

          </div>

          <div className="workspace-btn-group">

           

            <button
  className="workspace-btn-pdf"
  disabled={
    !workspace?.report_readiness?.is_ready ||
    isYearLocked ||
    !reportingYearId ||
    selectedEntity==="all"
  }
  onClick={()=>{
    
    if(
      !workspace?.report_readiness?.is_ready
    ) return;

    navigate(
      `/dashboard/brsr-export/${reportingYearId}/${selectedEntity}`
    );
  }}
>

  <i className="fa-regular fa-file-pdf" />

  Generate BRSR PDF

</button>

          </div>

        </div>

        {/* COMPLETION */}

        <div
          style={{
            marginTop:"12px",
            fontSize:"14px",
            color:"#64748B"
          }}
        >

          Completion:

          {" "}

          {
            workspace?.report_readiness
              ?.completion_percentage || 0
          }%

        </div>

        {/* SUMMARY CARDS */}

        <div className="stats-row">

          {statCards.map((s)=>(

            <div
              key={s.key}
              className="stat-card"
            >

              <div
                className="stat-icon"
                style={{
                  "--icon-bg":s.color,
                  "--icon-fg":s.fg
                }}
              >

                <i className={s.icon} />

              </div>

              <div>

                <div className="stat-title">

                  {s.label}

                </div>

                <div className="stat-value">

                  {s.value}

                </div>

                {s.sub && (

                  <span className="stat-sub">

                    {s.sub}

                  </span>

                )}

              </div>

            </div>

          ))}

        </div>

      </div>

      {/* =====================================
          DERIVED WORKSPACES
      ===================================== */}

      <div className="le-card workspace-derived-container">

        <div className="workspace-sections-heading">

          Derived Workspaces

        </div>

        <div className="workspace-sections-grid-layout">

          {sections.map((sec)=>(

            <div
              key={sec.section}
              onClick={()=>
  navigate(
    sec.url,
    {
      state:{
        reportingYearId,
        reportingYear,
        legalEntityId:selectedEntity,
        legalEntityName:
          workspace?.legal_entity?.name
      }
    }
  )
}
              className="workspace-grid-tile"
            >

              <div className="workspace-tile-body">

                <div className="workspace-tile-icon-box">

                  <i className={
                    sec.section==="A"
                      ? "fa-solid fa-book-open"
                      : sec.section==="B"
                      ? "fa-solid fa-clipboard-list"
                      : sec.section==="C"
                      ? "fa-solid fa-chart-line"
                      : "fa-solid fa-file-export"
                  } />

                </div>

                <div className="workspace-tile-text-meta">

                  <span className="workspace-tile-tag">

                    {sec.section}

                  </span>

                  <span className="workspace-tile-title">

                    {sec.title}

                  </span>

                  <span className="workspace-tile-desc">

                    {sec.description}

                  </span>

                </div>

              </div>

              <i className="fa-solid fa-arrow-right workspace-tile-arrow" />

            </div>

          ))}

        </div>

      </div>

     

     
</>

)}
{!workspace && (
        <div className="st-empty-entity">
          <div className="st-empty-entity__icon">
            <i className="fa-solid fa-building" />
          </div>
          <div className="st-empty-entity__title">Select a Legal Entity to continue</div>
          <div className="st-empty-entity__sub">
            Select a legal entity above to review Section A, B and C disclosures, validate Principle-wise readiness, verify supporting evidence, and generate the final SEBI BRSR Report for export.
 </div>
        </div>
      )}
    </div>
  );
};

export default BRSRWorkspace;